<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Clientes"
          buttonText="Novo cliente"
          :buttonFunction="openRegisterClientModal"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <download-excel
                  :data="data"
                  :fields="json_fields"
                  name="clientes.xls"
                >
                  <v-btn
                    :disabled="data.length > 0 ? false : true"
                    block
                    color="success"
                    class="mt-4 white--text"
                  >
                    Exportar
                    <v-icon right>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
          :headers="headers"
          :items="data"
          :search="search"
          class="elevation-1 mt-2"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.id }}</td>
              <td class>{{ item.name }}</td>
              <td class>{{ item.user ? item.user.name : '-' }}</td>
              <td class>{{ item.type_client }}</td>
              <td class>{{ item.status == true ? 'Ativo' : 'Inativo' }}</td>
              <td class>
                {{
                  item.client_id_parent
                    ? item.client_id_parent
                    : item.type_client == 'frotas'
                    ? 'Matriz'
                    : '---'
                }}
              </td>
              <td>
                <ActionButton
                  message="Editar cliente"
                  icon="mdi-pencil"
                  @onclick="editItem(item)"
                />
                <ActionButton
                  :message="
                    item.status ? 'Inativar cliente' : 'Ativar cliente'
                  "
                  :icon="
                    item.status ? 'mdi-power' : 'mdi-play-circle-outline'
                  "
                  :color="item.status ? 'error' : 'success'"
                  @onclick="statusItem(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="register_client_modal" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{
                this.client.id ? 'Editar Cliente' : 'Novo Cliente'
              }}</span>
            </v-card-title>
            <v-card-title>
              <v-tabs>
                <v-tab @click="viewModel('client')">Dados Cliente</v-tab>
                <v-tab @click="viewModel('adm')">Administrador</v-tab>
              </v-tabs>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md v-if="viewModal == 'client'">
                <v-layout>
                  <v-flex sm12>
                    <v-checkbox
                      v-model="client.isDeveloperClient"
                      label="Cliente para uso da T.I?"
                    >
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm6>
                    <v-select
                      v-model="client.type_client"
                      :rules="[
                        () =>
                          (this.client.type_client != '' &&
                            this.client.type_client != undefined) ||
                          'Esse campo é obrigatório.',
                      ]"
                      :items="typeClient"
                      :disabled="client.id ? true : false"
                      item-text="text"
                      item-value="value"
                      label="Tipo do cliente"
                      required
                      outlined
                      dense
                    ></v-select>
                  </v-flex>

                  <v-flex sm6>
                    <v-dialog
                      ref="dialog_mobilization_date"
                      v-model="mobilization_date"
                      :return-value.sync="client.mobilization_date"
                      persistent
                      lazy
                      max-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="client.mobilization_date"
                          label="Previsão de mobilização"
                          append-icon="event"
                          readonly
                          v-on="on"
                          outlined
                          dense
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        v-model="client.mobilization_date"
                        scrollable
                        class="color"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          flat
                          color="primary"
                          @click="mobilization_date = false"
                          >Cancelar</v-btn
                        >
                        <v-btn
                          flat
                          color="primary"
                          @click="
                            $refs.dialog_mobilization_date.save(
                              client.mobilization_date
                            )
                          "
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>

                  <v-flex sm12>
                    <v-text-field
                      label="Cliente"
                      v-model="client.name"
                      :rules="[
                        () =>
                          (this.client.name != '' &&
                            this.client.name != undefined) ||
                          'Esse campo é obrigatório.',
                      ]"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>

                  <v-flex sm6>
                    <v-text-field
                      label="Email do Cliente"
                      v-model="client.email_client"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6>
                    <v-text-field
                      v-model="client.phone_client"
                      label="Telefone do cliente"
                      v-mask="'(##)#####-####'"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>

                  <v-flex v-if="client.type_client == 'condominio'" sm6>
                    <v-text-field
                      type="number"
                      label="Vaga por apartamento"
                      v-model="client.vacancy_per_apt"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>

                  <v-flex v-if="client.type_client == 'condominio'" sm6>
                    <v-text-field
                      type="number"
                      :rules="[
                        () =>
                          /^\d+$/.test(this.client.housing_unit) ||
                          'Esse campo deve conter um número inteiro.',
                      ]"
                      label="Unidade habitacional (opcional)"
                      v-model="client.housing_unit"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>

                  <v-flex v-if="client.type_client == 'condominio'" sm12>
                    <v-row>
                      <v-col cols="5">
                        <v-text-field
                          v-model="client.initial_age_group"
                          label="Faixa etária inicial"
                          type="number"
                          min="2"
                          :counter="2"
                          maxlength="2"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="2"
                        class="d-flex justify-center align-center"
                      >
                        <span>até</span>
                      </v-col>
                      <v-col cols="5">
                        <v-text-field
                          v-model="client.final_age_group"
                          label="Faixa etária final"
                          type="number"
                          min="0"
                          :counter="2"
                          maxlength="2"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-flex>

                  <v-flex sm6>
                    <v-combobox
                      v-model="client.class"
                      :items="classes"
                      label="Classe"
                      maxlength="1"
                      outlined
                      dense
                    />
                  </v-flex>

                  <v-flex v-if="client.type_client == 'condominio'" sm12>
                    <BuscaUsuario 
                      :outlined="true" 
                      :dense="true"
                      :user="consultor"
                      @selectUser="selectUser"
                      />
                  </v-flex>

                  <v-flex v-if="client.type_client == 'condominio'" sm12>
                    <label>Meta mensal de faturamento</label>
                    <money
                      v-model="client.billing_target"
                      v-bind="money"
                      class="form-control"
                    ></money>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container v-if="viewModal == 'adm'">
                <v-layout wrap>
                  <v-list v-for="(admin, i) in admins" :key="i">
                      <v-list-item>
                        <h6>ADM: {{ i + 1 }}</h6>
                      </v-list-item>
                      <v-list-item >
                        <v-flex sm6>
                          <v-text-field
                            label="Nome do Administrador"
                            v-model="admin.user.name"
                            disabled
                            outlined
                            dense
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm6 pl-6>
                          <v-text-field
                            label="Telfone"
                            v-model="admin.user.phone"
                            v-mask="'(##)#####-####'"
                            disabled
                            outlined
                            dense
                          ></v-text-field>
                        </v-flex>
                      </v-list-item>
                      <v-list-item>
                        <v-flex sm6>
                          <v-text-field
                            label="CPF"
                            v-model="admin.user.cpf"
                            v-mask="'###.###.###-##'"
                            disabled
                            outlined
                            dense
                          ></v-text-field>
                        </v-flex>
                        <v-flex sm6 pl-6>
                          <v-text-field
                            label="E-mail"
                            v-model="admin.user.email "
                            disabled
                            outlined
                            dense
                          ></v-text-field>
                        </v-flex>
                      </v-list-item>         
                  </v-list>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click="clear()"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" flat @click="save()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import ClientController from '../../controllers/ClientController.js';
import Client from '../../models/Client';
import User from '../../models/User';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import { ValidateCPF } from '../../helpers/Validators';
import ActionButton from '../shared/ActionButtonsTemplate';

import TitleWithButton from '../../UIComponents/titleWithButton.vue';
import BuscaUsuario from '../shared/BuscaUsuario.vue'

export default {
  components: {
    TitleWithButton,
    ActionButton,
    BuscaUsuario,
  },
  async created() {
    await this.getClients();
  },
  data() {
    return {
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      clientController: new ClientController(this.$resource),
      client: new Client(),
      mobilization_date: false,
      user: new User(),
      data: [],
      admins: [],
      password: '',
      search: '',
      model: '',
      consultor: [],
      classes: ['A', 'B', 'C'],
      json_fields: {
        Cliente: 'name',
        Consultor: 'user.name',
        Tipo: 'type_client',
        Status: 'status',
      },
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'CLIENTE', value: 'name' },
        { text: 'CONSULTOR', value: 'user.name' },
        { text: 'TIPO', value: 'type_client' },
        { text: 'STATUS', value: 'status' },
        { text: 'ID DA MATRIZ', value: 'client_id_parent' },
        { text: 'AÇÕES', value: 'acoes', sortable: false},
      ],
      register_client_modal: false,
      typeClient: [
        { value: 'concessionaria', text: 'Concessionária' },
        { value: 'condominio', text: 'Condomínio' },
        // { value: 'usecarmais', text: 'UseCar+' },
        { value: 'frotas', text: 'Frotas' },
      ],
      client_id_parent: null,
      isMatrix: true,
      clientsFleetMatrix: [],
      mobilization_date: false,
      formHasErrors: false,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false,
        prefix: 'R$ ',
      },
      viewModal: 'client',
    };
  },
  computed: {
    isFleetMatrix() {
      return this.client.client_id_parent != null ? false : true;
    },
  },
  methods: {
    editItem(item) {
      this.getAdmins(item.id);
      this.client = Object.assign({}, item);
      this.consultor = item.user ? item.user : '';
      this.client.consultant_user_id = item.user ? item.user.name : null;
      this.client.billing_target = this.client.billing_target / 100;
      this.register_client_modal = true;
    },

    selectUser (value) {
      console.log(value)
      this.client.consultant_user_id = value.id
      console.log(this.client)
    },

    clear() {
      this.register_client_modal = false
      this.client = {}
    },

    statusItem(item) {
      this.client = Object.assign({}, item);
      this.changeStatusClient();
    },
    
    changeStatusClient() {
      let status = this.client.status ? 'inativar' : 'ativar';
      let icon = this.client.status ? 'error' : 'success';
      swal({
        title: 'Deseja ' + status + ' cliente ?',
        text: 'Informe a senha',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Digite aqui',
            type: 'password',
          },
        },
        icon: icon,
        buttons: true,
        dangerMode: true,
      }).then(change => {
        if (change) {
          this.password = change;
          if (status === 'inativar') {
            this.clientController
              .inactivate(this.client.id, this.password)
              .then(
                res => {
                  this.getClients();
                  this.$awn.success(res.message);
                },
                error => {
                  this.$awn.alert(error.body.message);
                }
              );
          } else {
            this.client.status = true;
            this.client.mobilization_date = new Date()
              .toISOString()
              .substr(0, 10);
            this.client.demobilization_date = null;
            this.clientController.update(this.client).then(
              res => {
                this.getClients();
                this.$awn.success('Status do cliente alterado com sucesso.');
              },
              error => {
                this.$awn.alert(error.message);
              }
            );
          }
        }
      });
    },

    async getClients() {
      try {
        this.blockScreen = true;
        this.data = await this.clientController.getClientsByFilters();
        if (this.data.length > 0) {
          // Tipo Frotas: Clientes matriz
          let fleetMatrix = this.data.filter(obj => {
            return (
              obj.client.status &&
              obj.client.type_client == 'frotas' &&
              obj.client.client_id_parent == null
            );
          });

          // Clientes matriz: Registros unicos
          fleetMatrix = fleetMatrix.filter(
            (value, index, self) =>
              self.findIndex(m => m.client.id === value.client.id) === index
          );

          // Normalizando objeto para o input do tipo select
          this.clientsFleetMatrix = fleetMatrix.map(obj => {
            return { text: obj.client.name, value: obj.client.id };
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.blockScreen = false;
      }
    },

    async getAdmins(clientId) {
      try {
        this.blockScreen = true;
        this.admins = await this.clientController.getAdminsByClient(clientId);
        console.log(this.admins)
      } catch (error) {
        console.log(error);
      } finally {
        this.blockScreen = false;
      }
    },

    isFormValid() {
      return (
        this.user.name != '' &&
        this.user.name != undefined &&
        this.user.phone != '' &&
        this.user.phone != undefined &&
        this.client.name != '' &&
        this.client.name != undefined &&
        this.user.email != '' &&
        this.user.email != undefined &&
        this.user.cpf != '' &&
        this.user.cpf != undefined &&
        this.client.type_client != '' &&
        this.client.type_client != undefined &&
        /^\d+$/.test(this.client.housing_unit)
      );
    },
    async save() {
      try {
        this.formHasErrors = !this.isFormValid();
        if (this.formHasErrors && !this.client.id) {
          this.$awn.alert(
            'Verifique se todos os dados no formulário estão corretos e preenchido'
          );
          return;
        }

        this.blockScreen = true;
        let response = null;

        if (!this.client.id && !ValidateCPF(this.user.cpf.replace(/\.|\-/gi, '')) ) {
          return this.$awn.alert('CPF está inválido!');
        }

        if (this.isMatrix) {
          this.client.client_id_parent = null;
        }

        if (this.client.billing_target) {
          this.client.billing_target = this.client.billing_target * 100;
        }

        this.client.phone_client = this.client.phone_client 
          ? this.client.phone_client.replace(/[^\d]/g,'') 
          : this.client.phone_client;
        
        if ( !this.client.id ) {
          this.user.phone = this.user.phone.replace(/[^\d]/g, '');
        }

        this.client.consultant_user_id ? this.client.consultant_user_id : null

        if (this.client.id) {
          console.log(this.client)
          response = await this.clientController.update(this.client);
        } else {
          response = await this.clientController.register(
            this.client,
            this.user
          );
        }

        this.$awn.success(response.message);
        this.register_client_modal = false;
        this.cleanForm();
        this.getClients();
      } catch (e) {
        console.log(e);
        this.$awn.alert(e.message);
      } finally {
        this.blockScreen = false;
        this.client.billing_target = this.client.billing_target / 100;
      }
    },

    openRegisterClientModal() {
      this.cleanForm();
      this.register_client_modal = true;
    },

    cleanForm() {
      this.client = new Client();
      this.user = new User();
    },

    handleSelectionChange(val) {
      this.selectedRow = val;
    },
    viewModel(val) {
      this.viewModal = val;
    },
  },
};
</script>
<style>
.table-custom-vue {
  margin: 25px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
</style>
